import React, { useState, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useTheme } from 'styled-components'
import { GeoAlt } from 'react-bootstrap-icons'
import AiOutlineClose from '@meronex/icons/ai/AiOutlineClose'
import TiWarningOutline from '@meronex/icons/ti/TiWarningOutline'

import {
  Header as HeaderContainer,
  InnerHeader,
  LogoHeader,
  LeftHeader,
  RightHeader,
  Menu,
  MenuLink,
  SubMenu,
  CustomerInfo,
  UserEdit,
  AddressMenu,
  MomentMenu,
  FarAwayMessage,
  Divider,
  AddressFormWrapper,
  LanguageSelectorWrapper,
  CurrencySelectorWrapper,
  HeaderSearchMode,
  LeftSide
} from './styles'

import { useSession, useLanguage, useOrder, useEvent, useConfig, useCustomer, useUtils, useBusiness } from '~components'
import { publicAssetUrl } from '~/utils/publicAssetUrl'
import {
  LanguageSelector,
  useWindowSize,
  useOnlineStatus,
  getDistance,
  getCateringValues,
  Confirm,
  Modal,
  Button,
  OrderTypeSelectorContent,
  UserPopover,
  CartPopover,
  OrderTypeSelectorHeader,
  CartContent,
  MomentContent,
  AddressList,
  AddressForm,
  HeaderOption,
  SidebarMenu,
  UserDetails,
  LoginForm,
  SignUpForm,
  ForgotPasswordForm,
  SearchBar,
  BusinessPreorder,
  Select,
  useCurrency
} from '~ui'

export const Header = (props) => {
  const {
    location,
    isHideSignup,
    isCustomerMode,
    searchValue,
    setSearchValue,
    businessSlug,
    notificationState,
    singleBusinessConfig
  } = props

  const isSingleBusiness = !!singleBusinessConfig?.isActive
  const { pathname } = useLocation()
  const [events] = useEvent()
  const [{ parseDate }] = useUtils()
  const [, t] = useLanguage()
  const [{ auth, user }, { login }] = useSession()
  const [orderState, { refreshOrderOptions }] = useOrder()
  const [openPopover, setOpenPopover] = useState({})
  const theme = useTheme()
  const websiteThemeType = theme?.my_products?.components?.website_theme?.components?.type
  const websiteThemeBusinessSlug = theme?.my_products?.components?.website_theme?.components?.business_slug
  const isSingleStoreTheme = websiteThemeType === 'single_store' && websiteThemeBusinessSlug

  const [configState] = useConfig()
  const [customerState, { deleteUserCustomer }] = useCustomer()
  const [{ business }] = useBusiness()
  const { currency, currencies, changeCurrency, hasEcocashConfig } = useCurrency()

  const clearCustomer = useRef(null)
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [customerModalOpen, setCustomerModalOpen] = useState(false)
  const [authModalOpen, setAuthModalOpen] = useState(false)
  const [modalSelected, setModalSelected] = useState(null)
  const [modalPageToShow, setModalPageToShow] = useState(null)
  const [preorderBusiness, setPreorderBusiness] = useState(null)
  const [isAddressFormOpen, setIsAddressFormOpen] = useState(false)
  const [isOpenUserData, setIsOpenUserData] = useState(false)
  const [confirm, setConfirm] = useState({ open: false, content: null, handleOnAccept: null })
  const [isFarAway, setIsFarAway] = useState(false)

  const isMulticheckoutPage = window.location.pathname?.includes('/multi-checkout')

  const cartsWithProducts = (orderState?.carts && Object.values(orderState?.carts).filter(cart => (cart.products && cart.products?.length > 0) || cart?.reservation)) || null
  const carts = businessSlug
    ? cartsWithProducts.filter((cart) => cart?.business?.slug === businessSlug || businessSlug === cart?.business_id)
    : cartsWithProducts

  const windowSize = useWindowSize()
  const onlineStatus = useOnlineStatus()

  let userCustomer = null
  try {
    const raw = window.localStorage.getItem('user-customer')
    if (raw) userCustomer = JSON.parse(raw)
  } catch {
    userCustomer = null
  }

  const orderTypeList = [t('DELIVERY', 'Delivery'), t('PICKUP', 'Pickup'), t('EAT_IN', 'Eat in'), t('CURBSIDE', 'Curbside'), t('DRIVE_THRU', 'Drive thru'), '', t('CATERING_DELIVERY', 'Catering Delivery'), t('CATERING_PICKUP', 'Catering pickup'), t('RESERVATION', 'Reservation')]
  const configTypes = configState?.configs?.order_types_allowed?.value.split('|').map(value => Number(value)) || []
  const isPreOrderSetting = configState?.configs?.preorder_status_enabled?.value === '1'
  const advancedSearchDisabled = configState?.configs?.advanced_business_search_enabled?.value === '0'
  const isHideLanguages = theme?.header?.components?.language_selector?.hidden
  const cateringTypeString = orderState?.options?.type === 7
    ? 'catering_delivery'
    : orderState?.options?.type === 8
      ? 'catering_pickup'
      : null

  const franchiseLayout = theme?.my_products?.components?.website_theme?.components?.franchise_slug
  const cateringValues = getCateringValues(cateringTypeString, pathname.includes('store') && Object?.keys(business || {})?.length > 0 ? business?.configs : configState?.configs)

  const currencyOptions = currencies?.map(curr => ({
    value: curr,
    content: curr
  })) || []

  const handleSuccessSignup = (user) => {
    closeAuthModal()
    login({
      user,
      token: user?.session?.access_token
    })
  }

  const handleClickUserCustomer = (e) => {
    const isActionsClick = clearCustomer.current?.contains(e?.target)
    if (isActionsClick) {
      setConfirm({
        open: true,
        content: t('QUESTION_CLEAR_CUSTOMER', theme?.defaultLanguages?.QUESTION_CLEAR_CUSTOMER || 'Are you sure that you want to clear the customer?'),
        handleOnAccept: () => {
          deleteUserCustomer(true)
          refreshOrderOptions()
          handleGoToPage({ page: 'home' })
          setConfirm({ ...confirm, open: false })
        }
      })
      return
    }
    setCustomerModalOpen(true)
  }

  const openModal = (opt) => {
    setModalSelected(opt)
    setModalIsOpen(true)
  }

  const handleTogglePopover = (type) => {
    setOpenPopover({
      ...openPopover,
      [type]: !openPopover[type]
    })
  }

  const handleClosePopover = (type) => {
    setOpenPopover({
      ...openPopover,
      [type]: false
    })
  }

  const handleGoToPage = (data) => {
    events.emit('go_to_page', data)
    if (isCustomerMode && pathname.includes('/orders')) {
      deleteUserCustomer(true)
      refreshOrderOptions()
    }
  }

  const handleCustomModalClick = (e, { page }) => {
    e.preventDefault()
    setModalPageToShow(page)
  }

  const closeAuthModal = () => {
    setAuthModalOpen(false)
    setModalPageToShow(null)
  }

  const handleSuccessLogin = (user) => {
    if (user) {
      closeAuthModal()
    }
  }

  const handleOpenLoginSignUp = (index) => {
    if (isCustomerMode) {
      events.emit('go_to_page', { page: 'home' })
    } else {
      setModalPageToShow(index)
      setAuthModalOpen(true)
    }
  }

  const handleClosePreorder = () => {
    setPreorderBusiness(null)
  }

  const handleBusinessClick = (business) => {
    events.emit('go_to_page', { page: 'business', params: { store: business.slug } })
  }

  const handleCustomEnter = (e) => {
    e.preventDefault()
    !advancedSearchDisabled && events.emit('go_to_page', { page: 'business_search' })
  }

  useEffect(() => {
    if (isCustomerMode) {
      setCustomerModalOpen(false)
    }
  }, [customerState?.user?.address])

  useEffect(() => {
    if (!(pathname.includes('/search') || pathname.includes('/checkout'))) {
      setIsFarAway(false)
      return
    }
    navigator.geolocation.getCurrentPosition((pos) => {
      const crd = pos.coords
      const distance = getDistance(crd.latitude, crd.longitude, orderState?.options?.address?.location?.lat, orderState?.options?.address?.location?.lng)
      if (distance > 20) setIsFarAway(true)
      else setIsFarAway(false)
    }, (err) => {
      console.warn(`ERROR(${err.code}): ${err.message}`)
    }, {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0
    })
  }, [orderState?.options?.address?.location, pathname])

  return (
    <HeaderContainer>
      <InnerHeader>
        <LeftSide>
          <LeftHeader id='left-side'>
            <SidebarMenu
              notificationState={notificationState}
              auth={auth}
              isHideSignup={isHideSignup}
              userCustomer={userCustomer ?? user}
              isCustomerMode={isCustomerMode}
              businessSlug={businessSlug}
            />
            <LogoHeader
              onClick={() =>
                handleGoToPage(
                  isSingleStoreTheme
                    ? { page: 'business', params: { business_slug: websiteThemeBusinessSlug } }
                    : {
                        page:
                          orderState?.options?.address?.location && !isCustomerMode
                            ? 'search'
                            : 'home'
                      }
                )}
            >
              <img
                alt='Logotype'
                width='170px'
                height='45px'
                src={(() => {
                  const apiLogo = theme?.my_products?.components?.images?.components?.logo?.components?.image
                  const raw = apiLogo || '/default-logo.png' || theme?.images?.logos?.logotype
                  return publicAssetUrl(raw)
                })()}
                loading='lazy'
              />
              <img
                alt='Isotype'
                width='35px'
                height='45px'
                loading='lazy'
                src={(() => {
                  const w = windowSize.width <= 768
                  const apiMobile = theme?.my_products?.components?.images?.components?.logo_mobile?.components?.image
                  const apiDesktop = theme?.my_products?.components?.images?.components?.logo?.components?.image
                  const fallback = w ? theme?.images?.logos?.isotypeInvert : theme?.images?.logos?.isotype
                  const raw = w
                    ? (apiMobile || '/default-logo.png' || fallback)
                    : (apiDesktop || '/default-logo.png' || fallback)
                  return publicAssetUrl(raw)
                })()}
              />
            </LogoHeader>
          </LeftHeader>
          {windowSize.width >= 576 && (
            <Menu id='center-side' className='left-header' isCustomerMode={isCustomerMode}>
              {windowSize.width > 850 && isFarAway && (
                <FarAwayMessage>
                  <TiWarningOutline />
                  <span>{t('YOU_ARE_FAR_FROM_ADDRESS', 'You are far from this address')}</span>
                </FarAwayMessage>
              )}
              {isCustomerMode && (
                <>
                  <AddressMenu
                    isCustomerMode={isCustomerMode}
                    onClick={(e) => handleClickUserCustomer(e)}
                  >
                    <GeoAlt />
                    <span>{orderState.options?.address?.address || t('LANG_WHAT_IS_YOUR_ADDRESS', 'What\'s your address?')}</span>
                  </AddressMenu>
                  <Divider />
                </>
              )}
              {isCustomerMode && windowSize.width > 450 && (
                <>
                  <CustomerInfo
                    onClick={(e) => handleClickUserCustomer(e)}
                  >
                    <span>
                      <p>{userCustomer?.name} {userCustomer?.lastname}</p>
                    </span>
                    <span
                      ref={clearCustomer}
                    >
                      <AiOutlineClose />
                    </span>
                  </CustomerInfo>
                  <Divider />
                </>
              )}
              {onlineStatus && windowSize.width > 820 && (
                <>
                  {!isCustomerMode && (
                    <AddressMenu
                      onClick={() => openModal('address')}
                    >
                      <GeoAlt />
                      <span>
                        <p>
                          {orderState.options?.address?.address || t('WHAT_IS_YOUR_ADDRESS', 'What\'s your address?')}
                        </p>
                      </span>
                    </AddressMenu>
                  )}
                  {!isCustomerMode && (isPreOrderSetting || configState?.configs?.preorder_status_enabled?.value === undefined) && (
                    <MomentMenu
                      $isFranchiseSlugOne={franchiseLayout === 'franchise_1'}
                      onClick={configState?.configs?.max_days_preorder?.value === -1 || configState?.configs?.max_days_preorder?.value === 0
                        ? null
                        : () => openModal('moment')}
                    >
                      <div>
                        {orderState.options?.moment
                          ? parseDate(orderState.options?.moment, { outputFormat: configState?.configs?.dates_moment_format?.value })
                          : t('ASAP_ABBREVIATION', 'ASAP')}
                      </div>
                    </MomentMenu>
                  )}
                </>
              )}
              {franchiseLayout !== 'franchise_1' && (
                <>
                  {windowSize.width > 768
                    ? (
                      <OrderTypeSelectorHeader
                        orderTypeList={orderTypeList}
                        onClick={() => openModal('delivery')}
                      />
                      )
                    : (
                      <HeaderOption
                        variant='delivery'
                        onClick={(variant) => openModal(variant)}
                        orderTypeList={orderTypeList}
                      />
                      )}
                </>
              )}
            </Menu>
          )}
        </LeftSide>
        {windowSize.width > 1200 && window.location.pathname === '/search' && (
          <HeaderSearchMode>
            <a href={advancedSearchDisabled ? null : '/business_search'}>
              <SearchBar
                lazyLoad
                search={searchValue}
                placeholder={t('SEARCH_BUSINESSES', 'Search Businesses')}
                starbucksStyle
                onSearch={(value) => setSearchValue(value)}
                handleCustomEnter={(e) => advancedSearchDisabled
                  ? null
                  : handleCustomEnter(e)}
              />
            </a>
          </HeaderSearchMode>
        )}
        {onlineStatus && (
          <RightHeader id='right-side'>
            <Menu isCustomerMode={isCustomerMode}>
              {hasEcocashConfig && currencyOptions.length > 0 && (
                <CurrencySelectorWrapper>
                  <Select
                    defaultValue={currency}
                    options={currencyOptions}
                    onChange={(value) => changeCurrency(value)}
                    showInvalidAsPlaceholder
                    notAsync
                    notReload
                  />
                </CurrencySelectorWrapper>
              )}
              {
                !auth && windowSize.width > 920 && (
                  <>
                    <MenuLink
                      name='signin'
                      style={{ whiteSpace: 'nowrap' }}
                      onClick={() => handleOpenLoginSignUp('login')}
                    >
                      {t('LOGIN', theme?.defaultLanguages?.LOGIN || 'Login')}
                    </MenuLink>
                    {!isHideSignup && (
                      <Button
                        type='button'
                        color='primary'
                        name='signup'
                        onClick={() => handleOpenLoginSignUp('signup')}
                      >
                        {t('SIGN_UP', theme?.defaultLanguages?.SIGN_UP || 'Sign up')}
                      </Button>
                    )}
                  </>
                )
              }
              {
                auth && (
                  <>
                    {windowSize.width > 768
                      ? !isMulticheckoutPage
                          ? <CartPopover
                          open={openPopover.cart}
                          carts={carts}
                          onClick={() => handleTogglePopover('cart')}
                          onClose={() => handleClosePopover('cart')}
                          auth={auth}
                          location={location}
                          isCustomerMode={isCustomerMode}
                          setPreorderBusiness={setPreorderBusiness}
                        />
                          : null
                      : <HeaderOption
                        variant='cart'
                        totalCarts={carts?.length}
                        onClick={(variant) => openModal(variant)}
                      />
                    }
                    {windowSize.width > 768 && (
                      <UserPopover
                        withLogout
                        isCustomerMode={isCustomerMode}
                        open={openPopover.user}
                        handleOpenAddressModal={() => openModal('address')}
                        onClick={() => handleTogglePopover('user')}
                        onClose={() => handleClosePopover('user')}
                      />
                    )}
                  </>
                )
              }
              {!isHideLanguages && (
                <LanguageSelectorWrapper>
                  <LanguageSelector />
                </LanguageSelectorWrapper>
              )}
            </Menu>
          </RightHeader>
        )}
      </InnerHeader>
      {onlineStatus && !props.isCustomLayout && !isCustomerMode && (
        windowSize.width > 768 && windowSize.width <= 820
          ? (
            <SubMenu>
              {isFarAway && (
                <FarAwayMessage>
                  <TiWarningOutline />
                  <span>{t('YOU_ARE_FAR_FROM_ADDRESS', 'You are far from this address')}</span>
                </FarAwayMessage>
              )}
              <AddressMenu onClick={() => openModal('address')}>
                <GeoAlt /> {orderState.options?.address?.address || t('WHAT_IS_YOUR_ADDRESS', 'What\'s your address?')}
              </AddressMenu>
              {!isCustomerMode && (isPreOrderSetting || configState?.configs?.preorder_status_enabled?.value === undefined) && (
                <HeaderOption
                  variant='moment'
                  momentState={orderState?.options?.moment}
                  onClick={configState?.configs?.max_days_preorder?.value === -1 || configState?.configs?.max_days_preorder?.value === 0
                    ? null
                    : (variant) => openModal(variant)}
                />
              )}
            </SubMenu>
            )
          : (
              windowSize.width >= 576 && (
              <SubMenu>
                {isFarAway && (
                  <FarAwayMessage>
                    <TiWarningOutline />
                    <span>{t('YOU_ARE_FAR_FROM_ADDRESS', 'You are far from this address')}</span>
                  </FarAwayMessage>
                )}
                <HeaderOption
                  variant='address'
                  addressState={orderState?.options?.address?.address}
                  onClick={(variant) => openModal(variant)}
                  containerStyle={{ width: '80%' }}
                />
                {!isCustomerMode && (isPreOrderSetting || configState?.configs?.preorder_status_enabled?.value === undefined) && (
                  <HeaderOption
                    variant='moment'
                    momentState={orderState?.options?.moment}
                    onClick={configState?.configs?.max_days_preorder?.value === -1 || configState?.configs?.max_days_preorder?.value === 0
                      ? null
                      : (variant) => openModal(variant)}
                  />
                )}
              </SubMenu>
              )
            )
      )}
      {modalIsOpen && (
        <Modal
          {...(!auth && modalSelected === 'address' && { title: t('WHAT_IS_YOUR_ADDRESS', 'What\'s your address?') })}
          open={modalIsOpen}
          onClose={() => setModalIsOpen(false)}
          width={modalSelected === 'address' ? orderState?.options?.user_id ? '70%' : '50%' : '700px'}
        >
          {modalSelected === 'cart' && (
            <CartContent
              carts={carts}
              isOrderStateCarts={!!orderState.carts}
              onClose={() => setModalIsOpen(false)}
            />
          )}
          {modalSelected === 'address' && (
            auth
              ? (
                <AddressList
                  isModal
                  changeOrderAddressWithDefault
                  userId={isNaN(userCustomer?.id) ? null : userCustomer?.id}
                  onCancel={() => setModalIsOpen(false)}
                  isCustomerMode={isCustomerMode}
                />
                )
              : (
                <AddressFormWrapper>
                  <AddressForm
                    useValidationFileds
                    address={orderState?.options?.address || {}}
                    onCancel={() => setModalIsOpen(false)}
                    onSaveAddress={() => setModalIsOpen(false)}
                    isCustomerMode={isCustomerMode}
                  />
                </AddressFormWrapper>
                )
          )}
          {modalSelected === 'moment' && (
            <MomentContent
              onClose={() => setModalIsOpen(false)}
              cateringPreorder={!!cateringTypeString}
              isHeader
              business={(pathname.includes('store') && business) || isSingleBusiness}
              {...cateringValues}
            />
          )}
          {modalSelected === 'delivery' && (
            <OrderTypeSelectorContent
              onClose={() => setModalIsOpen(false)}
              configTypes={!configState?.loading && configTypes?.length > 0 ? configTypes : null}
              defaultValue={!(!configState?.loading && configTypes?.length > 0) && 1}
            />
          )}
        </Modal>
      )}
      {isCustomerMode && customerModalOpen && (
        <Modal
          open={customerModalOpen}
          width='80%'
          onClose={() => setCustomerModalOpen(false)}
          padding='20px'
          hideCloseDefault
        >
          <UserEdit>
            {!customerState?.loading && (
              <>
                <UserDetails
                  isAddressFormOpen={isAddressFormOpen}
                  userData={customerState?.user}
                  userId={customerState?.user?.id}
                  isOpenUserData={isOpenUserData}
                  isCustomerMode
                  isModal
                  setIsOpenUserData={setIsOpenUserData}
                  onClose={() => setCustomerModalOpen(false)}
                />
                <AddressList
                  isModal
                  userId={customerState?.user?.id}
                  changeOrderAddressWithDefault
                  userCustomerSetup={customerState.user}
                  isOpenUserData={isOpenUserData}
                  setCustomerModalOpen={setCustomerModalOpen}
                  setIsOpenUserData={setIsOpenUserData}
                  setIsAddressFormOpen={setIsAddressFormOpen}
                  isHeader
                  isCustomerMode={isCustomerMode}
                />
              </>
            )}
          </UserEdit>
        </Modal>
      )}
      {authModalOpen && !auth && (
        <Modal
          open={authModalOpen}
          onRemove={() => closeAuthModal()}
          onClose={() => closeAuthModal()}
          width='50%'
          authModal
          closeOnBackdrop
        >
          {modalPageToShow === 'login' && (
            <LoginForm
              notificationState={notificationState}
              handleSuccessLogin={handleSuccessLogin}
              elementLinkToSignup={
                <a
                  onClick={
                    (e) => handleCustomModalClick(e, { page: 'signup' })
                  } href='#'
                >{t('CREATE_ACCOUNT', theme?.defaultLanguages?.CREATE_ACCOUNT || 'Create account')}
                </a>
              }
              elementLinkToForgotPassword={
                <a
                  onClick={
                    (e) => handleCustomModalClick(e, { page: 'forgotpassword' })
                  } href='#'
                >{t('RESET_PASSWORD', theme?.defaultLanguages?.RESET_PASSWORD || 'Reset password')}
                </a>
              }
              useLoginByCellphone
              isPopup
            />
          )}
          {modalPageToShow === 'signup' && (
            <SignUpForm
              notificationState={notificationState}
              elementLinkToLogin={
                <a
                  onClick={
                    (e) => handleCustomModalClick(e, { page: 'login' })
                  } href='#'
                >{t('LOGIN', theme?.defaultLanguages?.LOGIN || 'Login')}
                </a>
              }
              useLoginByCellphone
              useChekoutFileds
              handleSuccessSignup={handleSuccessSignup}
              isPopup
              closeModal={() => closeAuthModal()}
            />
          )}
          {modalPageToShow === 'forgotpassword' && (
            <ForgotPasswordForm
              elementLinkToLogin={
                <a
                  onClick={
                    (e) => handleCustomModalClick(e, { page: 'login' })
                  } href='#'
                >{t('LOGIN', theme?.defaultLanguages?.LOGIN || 'Login')}
                </a>
              }
              isPopup
            />
          )}
        </Modal>
      )}
      <Confirm
        title={t('CUSTOMER', theme?.defaultLanguages?.CUSTOMER || 'Customer')}
        content={confirm.content}
        acceptText={t('ACCEPT', theme?.defaultLanguages?.ACCEPT || 'Accept')}
        open={isCustomerMode && confirm.open}
        onClose={() => setConfirm({ ...confirm, open: false })}
        onCancel={() => setConfirm({ ...confirm, open: false })}
        onAccept={confirm.handleOnAccept}
        closeOnBackdrop={false}
      />
      {!!preorderBusiness && (
        <Modal
          open={!!preorderBusiness}
          width='760px'
          onClose={() => handleClosePreorder()}
        >
          <BusinessPreorder
            business={preorderBusiness}
            handleClick={handleBusinessClick}
            showButton
          />
        </Modal>
      )}
    </HeaderContainer>
  )
}

export default Header
